import { useMutation } from '@tanstack/react-query';
import { catchBackendApiClient } from '@/client/customFetcher';
import type { PersonResponse } from '@/api/generated-catch-backend/model';

/**
 * Request body for creating person from questionnaire answers
 */
export interface CreatePersonFromQuestionnaireRequest {
  questionnaire_response_id: string;
}

/**
 * Create a person record from questionnaire answers.
 *
 * This endpoint extracts demographic data (first_name, birthday, sex, zip_code, email)
 * from the questionnaire response and creates a person record.
 *
 * - Idempotent: Returns existing person if already created
 * - Only works for the authenticated user's own questionnaire responses
 * - All demographic fields are optional
 */
export const useCreatePersonFromQuestionnaire = () => {
  return useMutation({
    mutationFn: async (data: CreatePersonFromQuestionnaireRequest): Promise<PersonResponse> => {
      const response = await catchBackendApiClient.post<PersonResponse>('/v1/persons/me', data);
      return response.data;
    },
  });
};
